import { Component, Input, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { Subscription } from 'rxjs';

@Component({
    selector: 'pv-shared-input-phone-number',
    templateUrl: './shared-input-phone-number.component.html',
    styleUrls: ['./shared-input-phone-number.component.scss'],
    standalone: false
})
export class SharedInputPhoneNumberComponent implements OnInit, OnChanges, OnDestroy {
  @Input() formGroup: FormGroup;
  @Input() controlName: string = "phone";
  @Input() placeholder: string | undefined;
  @Input() required: boolean = false;

  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  phoneForm: FormGroup;

  private subscription: Subscription;

  ngOnInit() {
    this.phoneForm = new FormGroup({
      [this.controlName]: new FormControl(undefined, this.required ? [Validators.required] : [])
    });

    if (this.formGroup && this.controlName) {
      const ctrl = this.formGroup.get(this.controlName);
      if (ctrl && ctrl.value) {
        this.phoneForm.get(this.controlName)?.setValue(ctrl.value);
      }

      this.subscription = this.formGroup.get(this.controlName).valueChanges.subscribe(value => {
        if (value) {
          this.phoneForm.get(this.controlName)?.setValue(value, { emitEvent: false });
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formGroup || changes.controlName) {
      if (this.formGroup && this.controlName) {
        const ctrl = this.formGroup.get(this.controlName);
        if (ctrl && ctrl.value) {
          this.phoneForm?.get(this.controlName)?.setValue(ctrl.value);
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onPhoneChange(event: any) {
    let formattedNumber = '';
    if (typeof event === 'string') {
      formattedNumber = event;
    } else if (event && typeof event === 'object' && event.e164Number) {
      formattedNumber = event.e164Number;
    }
    
    const phoneCtrl = this.phoneForm.get(this.controlName);
    phoneCtrl?.markAsTouched();
    const isTouched = phoneCtrl?.touched;
    const isValid = phoneCtrl?.valid || false;
    const isEmpty = !formattedNumber || formattedNumber.trim() === '';
    if (this.formGroup && this.controlName && isTouched) {
      const ctrl = this.formGroup.get(this.controlName);
      ctrl?.setValue(formattedNumber, { emitEvent: false });
      ctrl?.markAsTouched();
      if (this.required && isEmpty) {
        ctrl?.setErrors({ required: true });
      } else if (!isValid) {
        ctrl?.setErrors({ pattern: true });
      } else {
        ctrl?.setErrors(null);
      }
    }
  }
}